import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=3344bddd&"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports